<script setup lang="ts">
import {
  Carousel, Navigation, Slide, Pagination,
} from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import { ref, watchEffect, nextTick } from 'vue';

import { testimonies } from './testimonies';
import Testimony from './Testimony.vue';

// breakpoints are mobile first
// any settings not specified will fallback to the carousel settings
const breakpoints = {
  700: {
    itemsToShow: 2,
    snapAlign: 'center',
  },
  1024: {
    itemsToShow: 3,
    snapAlign: 'start',
  },
  2048: {
    itemsToShow: 4,
    snapAlign: 'start',
  },
};

// Make currentSlide reactive
const currentSlide = ref(0);

function handleSlideChange(newIndex: number) {
  currentSlide.value = newIndex;
  watchEffect(() => {
    nextTick(() => {
      const buttons = document.querySelectorAll('.carousel__pagination-button');
      buttons.forEach((btn, i) => {
        if (i === currentSlide.value) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.setAttribute('aria-current', 'false');
        }
      });
    });
  });
}

</script>

<template>
  <Carousel
    :breakpoints="breakpoints"
    :autoplay="5000"
    pause-autoplay-on-hover
    aria-roledescription="carousel"
    aria-label="testimonials"
    aria-live="false"
    @update:modelValue="handleSlideChange"
  >
    <Slide
      v-for="(testimony, index) in testimonies"
      :key="testimony.reviewer"
    >
      <div
        class="carousel__item h-full"
        :aria-hidden="index !== currentSlide"
        :tabindex="index === currentSlide ? 0 : -1"
        :aria-label="`Testimony by ${testimony.reviewer}`"
        role="group"
        aria-roledescription="slide"
      >
        <Testimony :testimony="testimony" class="h-full" />
      </div>
    </Slide>

    <template #addons>
      <Pagination
        role="navigation"
        aria-label="Carousel pagination"
      />
      <Navigation
        role="navigation"
        aria-label="Carousel navigation"
      />
    </template>
  </Carousel>
</template>

<style>
.carousel {
    --vc-pgn-height: 16px;
    --vc-pgn-width: 16px;
}
.carousel__item {
  width: 100%;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  background-color: transparent;
}

</style>
